/**
 * I have not the exactly string of the IE, for that, we can not include
 * this browsers in browsers constants.
 * @type {{FIREFOX: string, CHROME: string, SAFARI: string, OPERA: string}}
 */
export const BROWSERS = {
  // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10.13; rv:62.0) Gecko/20100101 Firefox/62.0"
  FIREFOX: 'Firefox',
  // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6) AppleWebKit/537.36
  // (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36"
  CHROME: 'Chrome',
  // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6) AppleWebKit/605.1.15
  // (KHTML, like Gecko) Version/12.0 Safari/605.1.15"
  SAFARI: 'Safari',
  // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6) AppleWebKit/537.36
  // (KHTML, like Gecko) Chrome/64.0.3282.168 Safari/537.36 OPR/51.0.2830.40"
  OPERA: 'OPR',
};

/**
 * The order of browsers is very important because when
 * we use "window.navigator.userAgent", some browsers
 * have 2 browser's version. For example, Opera prints:
 *
 * "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6)
 * AppleWebKit/537.36 (KHTML, like Gecko)
 * Chrome/64.0.3282.168
 * Safari/537.36
 * OPR/51.0.2830.40"
 *
 * For that, first we will check if it's Opera or other
 * browser.
 * @type {string[]}
 */
export const COMPATIBLE_BROWSERS = [
  BROWSERS.OPERA,
  BROWSERS.FIREFOX,
  BROWSERS.CHROME,
  BROWSERS.SAFARI,
];

export const search = browser => window.navigator.userAgent.search(browser) >= 0;

export const isOpera = () => search(BROWSERS.OPERA);

export const isFirefox = () => search(BROWSERS.FIREFOX);

export const isSafari = () => {
  const shouldNotBeInUserAgent = !search(BROWSERS.CHROME);

  const founded = search(BROWSERS.SAFARI);

  // When UserAgent has not chrome and it has Safari,
  // it's Safari
  return shouldNotBeInUserAgent && founded;
};

export const isChrome = () => search(BROWSERS.CHROME);

export const isIE = () => (!isOpera() && !isFirefox() && !isSafari() && !isChrome());

export const browserClassname = () => {
  const classname = 'browser';

  if (isIE()) {
    return `${classname}-ie`;
  }

  if (isOpera()) {
    return `${classname}-opera`;
  }

  if (isFirefox()) {
    return `${classname}-firefox`;
  }

  if (isChrome()) {
    return `${classname}-chrome`;
  }

  if (isSafari()) {
    return `${classname}-safari`;
  }

  return `${classname}-not-detected`;
};
